// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"a8f87740","638":"deb96bd0","843":"b61d0edf"}[chunkId] + ".chunk.js";
};